/* 三國逗陣打 · 雲端存檔（v0.2.1）：會員的進度存在伺服器，換裝置、清瀏覽器都不會不見
 * 登入時：雲端沒有 → 把這台的進度傳上去；雲端有 → 跟這台的合併（規則見 savemerge.ts）；
 *        這台的進度屬於別的帳號（owner 不同）→ 直接用雲端那份，不混在一起。
 * 之後每次存檔（Meta.save）延遲 2 秒上傳，切到背景時立刻上傳；其他裝置先改過（版本衝突）就合併後重傳。 */
// @ts-nocheck — 和 meta.ts 一樣，型別之後再補
import { SG } from '../core/sg.ts';
import { mergeProfiles } from './savemerge.ts';

const Meta = SG.Meta;
const C = { pid: null, rev: 0, state: 'off', at: 0, timer: 0, busy: false, again: false, listeners: [] };
C.on = (f) => C.listeners.push(f);
SG.Cloud = C;
const emit = () => C.listeners.forEach((f) => { try { f(C); } catch (e) { /* 忽略 */ } });
const set = (s) => { C.state = s; if (s === 'ok') C.at = Date.now(); emit(); };

async function api(method, body) {
  const r = await fetch('api/me/save', { method, cache: 'no-store', keepalive: method !== 'GET', headers: body ? { 'content-type': 'application/json' } : {}, body: body ? JSON.stringify(body) : undefined });
  let j = null; try { j = await r.json(); } catch (e) { /* 不是 JSON */ }
  return { status: r.status, j };
}
// 伺服器整理過的欄位（黃金不能憑空增加、銅錢取整）套回本機
const adopt = (j) => { if (j && j.fix) { Object.assign(Meta.profile, j.fix); Meta.replace(Meta.profile); } };

async function login(user) {
  if (!user) { C.pid = null; set('off'); return; }
  if (C.pid === user.pid) return;
  C.pid = user.pid; set('sync');
  try {
    const r = await api('GET');
    if (!r.j || !r.j.ok) { set('error'); return; }
    const P = Meta.profile, mine = !P.owner || P.owner === user.pid;
    const cloud = r.j.data;
    const next = cloud ? (mine ? mergeProfiles(cloud, P) : cloud) : (mine ? P : {});
    next.owner = user.pid;
    C.rev = r.j.rev || 0;
    Meta.replace(next);
    await push();
    if (SG.Home && SG.Home.show) SG.Home.show(SG.Home.tab); // 錢包、軍階等畫面重畫
  } catch (e) { set('error'); }
}
async function push() {
  if (!C.pid) return;
  if (C.busy) { C.again = true; return; }
  C.busy = true; set('sync');
  try {
    for (let tries = 0; tries < 3; tries++) {
      const r = await api('PUT', { data: Meta.profile, rev: C.rev });
      if (r.j && r.j.ok) { C.rev = r.j.rev; adopt(r.j); set('ok'); break; }
      if (r.status === 409 && r.j && r.j.server) { // 其他裝置剛更新過：合併後重傳
        C.rev = r.j.server.rev; const m = mergeProfiles(r.j.server.data, Meta.profile); m.owner = C.pid; Meta.replace(m); continue;
      }
      set('error'); break;
    }
  } catch (e) { set('error'); } finally { C.busy = false; }
  if (C.again) { C.again = false; schedule(); }
}
function schedule() { if (!C.pid) return; clearTimeout(C.timer); C.timer = setTimeout(push, 2000); }
C.push = push;
// 錢包（v0.2.2）：只由伺服器改動。套用伺服器回傳的錢包；呼叫經濟 API（shop/skin、shop/boost、shop/exchange、econ/practice）
C.applyWallet = (w, rev) => { if (!w) return; Object.assign(Meta.profile, w); Meta.replace(Meta.profile); if (rev) C.rev = rev; emit(); };
C.econ = async (path, body) => {
  let j = null;
  try { const r = await fetch('api/' + path, { method: 'POST', cache: 'no-store', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body || {}) }); j = await r.json(); } catch (e) { /* 連不上 */ }
  j = j || { ok: false, err: '連不上伺服器，請稍後再試' };
  if (j.wallet) C.applyWallet(j.wallet, j.rev);
  return j;
};

// 領取戰功與列傳星數的黃金（每個戰功 10、每顆星 5，各只領一次）：玩家按「領取」才呼叫。sel：{ ach: [戰功 id], stars: { 章節 id: 星數 } }
// 會員送伺服器（只發還沒領過的，回傳領過的紀錄）；訪客記在本機存檔
C.claimRewards = async (sel) => {
  const ach = sel.ach || [], stars = sel.stars || {};
  let got;
  if (C.pid) {
    const j = await C.econ('econ/claim', { ach, stars });
    if (!j.ok) { if (SG.Home && SG.Home.toast) SG.Home.toast(j.err || '領取失敗'); return null; }
    got = j.granted; Meta.profile.econ = Object.assign({}, Meta.profile.econ, { ach: j.claimed.ach, star: j.claimed.star }); Meta.replace(Meta.profile);
  } else { got = Meta.claimLocal(ach, stars); emit(); }
  if (got && got.gold && SG.Home && SG.Home.toast) SG.Home.toast(`獲得 ${got.gold} 黃金（${[got.ach && `戰功 ${got.ach} 個`, got.stars && `列傳 ${got.stars} 顆星`].filter(Boolean).join('、')}）`);
  return got;
};
Meta.onSave(() => { if (C.pid) { Meta.profile.owner = C.pid; schedule(); } });
document.addEventListener('visibilitychange', () => { if (document.hidden && C.pid && C.timer) { clearTimeout(C.timer); C.timer = 0; push(); } });
if (SG.Account) {
  SG.Account.onChange((u) => login(u));
  if (SG.Account.ready) SG.Account.ready.then(() => login(SG.Account.user));
}
